import React from 'react';

const Team = () => {
  const team = [
    {
      name: 'Keshara Hewage',
      role: 'CEO & Co-Founder',
      bio: 'Visionary leader with 5 years in digital transformation',
      image: '/images/keshara.jpg'
    },
    {
      name: 'Nipuna Hewage',
      role: 'Project Manager',
      bio: 'Ensuring seamless delivery and client satisfaction',
      icon: '👨‍💼'
    }
  ];

  return (
    <section id="team">
      <div className="section-header">
        <h2 className="section-title">Meet Our Team</h2>
        <p className="section-subtitle">Talented professionals dedicated to your success</p>
      </div>
      <div className="team-grid">
        {team.map((member, index) => (
          <div className="team-card fade-in" key={index} style={{animationDelay: `${(index % 3) * 0.15}s`}}>
            <div className="member-avatar">
              {member.image ? (
                <img src={member.image} alt={member.name} style={{width:80,height:80,borderRadius:'50%',objectFit:'cover',boxShadow:'0 4px 16px rgba(37,99,235,0.15)'}} />
              ) : (
                member.icon
              )}
            </div>
            <h4>{member.name}</h4>
            <p className="role">{member.role}</p>
            <p className="bio">{member.bio}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Team;
